import { Injectable } from '@angular/core';
import { PruHttpService } from "../services/pru-http.service";
import { Observable, of } from "rxjs";
import { SessionStorageService } from "../services/web-storage/session-storage.service";
import { shareReplay, map, catchError } from 'rxjs/operators';
declare var environment: any;

@Injectable({
  providedIn: "root"
})
export class FeatureListService {
  constructor(
    private _pruhttp: PruHttpService,
    private _sessionStorageService: SessionStorageService
  ) { }

  private strURL: string = environment.userEnabledFeatures;
  private key: string = "toggleFeatureList";
  private enabledKey: string = "enabledFeature";
  public toggleFeatureList: any;
  public enabledFeatureList: any;

  public getFeatureList(): Observable<any> {
      if (this.toggleFeatureList) {
        return of(this.toggleFeatureList);
      }
      // Check if Session Exists
      if (this._sessionStorageService.getItem(this.key)) {
        this.toggleFeatureList = this._sessionStorageService.getItem(this.enabledKey, true) || [];
        return of(this.toggleFeatureList);
      } else {
        return this._pruhttp.get(this.strURL, "feature-toggle").pipe(
          map(data => {
              this._sessionStorageService.setItem(this.key, data, true);
              this.toggleFeatureList = [];
              if (data["body"]) {
                data["body"].forEach((item: any) => {
                  if (/enable/i.test(item.featureStatus)) {
                    this.toggleFeatureList.push(item.featureName);
                  }
                });
                if (this.toggleFeatureList.length) {
                  this._sessionStorageService.setItem(this.enabledKey, this.toggleFeatureList, true);
                }
              }
              return this.toggleFeatureList;
            }),
          catchError((error) => {
            console.log("feature toggle error: ", error);
            return of([]);
          }),
          shareReplay()
        );
      }
  }
}
